// extracted by mini-css-extract-plugin
export var background = "_71-0";
export var container = "_71-1";
export var contentItem = "_71-7";
export var extendedWarranty = "_71-5";
export var link = "_71-d";
export var modal = "_71-b";
export var modalCloseButton = "_71-9";
export var modalContent = "_71-3";
export var modalContentMain = "_71-6";
export var modalImageLogo = "_71-8";
export var modalLogo = "_71-a";
export var modalSideImage = "_71-4";
export var preview = "_71-c";
export var redoModal = "_71-2";